import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Users } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_family-connect-195/artifacts/d7hehvno_Color%20logo%20with%20background.svg';

export default function CreateFamilyPage() {
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const [familyName, setFamilyName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/family`, { name: familyName }, { withCredentials: true });
      await refreshUser();
      toast.success('Family created successfully!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create family');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col items-center justify-center px-4" data-testid="create-family-page">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Kinsy" className="h-10 mx-auto mb-6" />
        </div>

        {/* Welcome Card */}
        <div className="card-soft text-center">
          <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-8 h-8 text-teal-600" />
          </div>
          <h1 className="text-2xl font-bold text-stone-900 mb-2">
            Create Your Family
          </h1>
          <p className="text-stone-500 mb-8">
            Set up your family space and start inviting members
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2 text-left">
              <Label htmlFor="familyName" className="text-stone-700">Family Name</Label>
              <Input
                id="familyName"
                type="text"
                value={familyName}
                onChange={(e) => setFamilyName(e.target.value)}
                placeholder="e.g., The Johnson Family"
                className="h-12 rounded-xl border-stone-200 focus:border-teal-500 focus:ring-teal-500"
                required
                data-testid="family-name-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-medium text-base"
              data-testid="create-family-btn"
            >
              {loading ? 'Creating...' : 'Create Family'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
